import React from "react";
import { ToastContainer } from "react-toastify";
import ViewMarketingBanner from "../../components/Settings/MarketingBanner/ViewMarketingBanner";

export const ViewMarketingBannerPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewMarketingBanner />
        </div>
      </div>
    </div>
  );
};
